<div class="container-fluid my-5" *ngIf="is_connected == true">
  <!-- Table -->
  <div class="row" *ngIf="currentUser.switch_account == 'manager_studio'">
    <div class="col">
      <div class="card border shadow p-4">
        <div class="align-items-center">
          <div class="d-flex justify-content-between pb-3">
            <div class="div">
              <h2>Content de te revoir, {{(currentUser.profile.full_name != "") ? currentUser.profile.full_name :
                '---'}}</h2>
            </div>
          </div>
        </div>
        <!-- credits -->
        <div class="row">
          <div class="col-xl-4 col-lg-6">
            <div class="card bg-secondary card-stats mb-4 mb-xl-0">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h5 class="card-title text-uppercase text-muted mb-0">mes studios</h5>
                    <span class="h2 font-weight-bold mb-0">{{ count_studios}}</span>
                  </div>
                  <div class="col-auto">
                    <div class="icon icon-shape bg-danger text-white rounded-circle shadow"><i class="fa fa-music"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6">
            <div class="card bg-secondary card-stats mb-4 mb-xl-0">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h5 class="card-title text-uppercase text-muted mb-0">réservations en attente</h5>
                    <span class="h2 font-weight-bold mb-0">{{count_requested_booking}}</span>
                  </div>
                  <div class="col-auto">
                    <div class="icon icon-shape bg-danger text-white rounded-circle shadow"><i
                        class="fa fa-spinner"></i></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6">
            <div class="card bg-secondary card-stats mb-4 mb-xl-0">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h5 class="card-title text-uppercase text-muted mb-0">réservations accepteés</h5>
                    <span class="h2 font-weight-bold mb-0">{{count_accepted_booking}}</span>
                  </div>
                  <div class="col-auto">
                    <div class="icon icon-shape bg-danger text-white rounded-circle shadow"><i class="fa fa-check"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- last reservations -->
        <div class="mt-4">
          <div class="row mt-5">
            <div class="col-12 mb-5 mb-xl-0">
              <div class="card shadow">
                <div class="card-header border-0">
                  <div class="row align-items-center">
                    <div class="col">
                      <h3 class="mb-0">Mes studios</h3>
                    </div>
                    <div class="col text-right">
                      <button class="btn btn-outline-studiomap" (click)="navigateTo('studios')">
                        <i class="fa fa-plus" style="margin: 0 !important;"></i> <span class="d-none d-lg-inline-block"
                          style="margin-left: 0.5rem;">Voir
                          plus</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table align-items-center table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th scope="col">Nom</th>
                          <th scope="col">Type</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let studio of studios">
                          <td>{{ studio.private_name }}</td>
                          <td><span class="badge badge-primary">{{ studio.type_name }}</span></td>
                          <td>
                            <button type="button" (click)="navigateTo('studios/edit/'+studio.id)"
                              class="btn btn-sm btn-icon-only text-warning" title="Edit">
                              <i class="fas fa-edit"></i>
                            </button>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                    <!-- loading state -->
                    <p class="text-center font-weight-bold mt-3" *ngIf="loading">
                      Chargement...</p>
                    <p class="text-center font-weight-bold mt-3" *ngIf="studios.length == 0 && !loading">
                      Aucun élément trouvé</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- reservations -->
        <div class="mt-4">
          <div class="row mt-5">
            <div class="col-12 mb-5 mb-xl-0">
              <div class="card shadow">
                <div class="card-header border-0">
                  <div class="row align-items-center">
                    <div class="col">
                      <h3 class="mb-0">Derniers réservations</h3>
                    </div>
                    <div class="col text-right">
                      <button class="btn btn-outline-studiomap" (click)="navigateTo('reservations')">
                        <i class="fa fa-plus" style="margin: 0 !important;"></i> <span class="d-none d-lg-inline-block"
                          style="margin-left: 0.5rem;">Voir
                          plus</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table align-items-center table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th scope="col">STUDIO</th>
                          <th scope="col">DATE</th>
                          <th scope="col">Status</th>
                          <th scope="col">Date de création</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let reservation of reservations">
                          <td scope="row">
                            <button type="button" (click)="navigateTo('details-studio?slug='+reservation.studio.slug)"
                              class="btn btn-sm btn-outline-primary">
                              <i class="fa fa-link"></i>{{reservation.studio_name}}
                            </button>
                          </td>
                          <td>
                            <strong>Nombre d'heures : </strong>{{reservation.nbr_hours}}H<br>
                            <strong>Debut : </strong>{{ date_format(reservation.start_date) }}<br>
                            <strong>Fin : </strong> {{ date_format(reservation.end_date) }}
                          </td>
                          <td>
                            <span class="{{ status[reservation.status]['class']}}">{{
                              status[reservation.status]['text']}}</span>
                          </td>
                          <td>
                            <span class="badge badge-info">{{ reservation.createdAt | date:
                              'dd-MM-yyyy'}}</span>
                          </td>
                          <td>
                            <button type="button" (click)="navigateTo('reservations/info/'+reservation.id)"
                              class="btn btn-sm btn-icon-only text-info" title="Détails">
                              <i class="fas fa-list"></i>
                            </button>
                            <button type="button" class="btn btn-sm btn-icon-only text-danger" title="Annuler"
                              (click)="annuler(reservation)" *ngIf="reservation.show_button_cancel">
                              <i class="fa-lg ni ni-fat-remove"></i>
                            </button>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                    <!-- loading state -->
                    <p class="text-center font-weight-bold mt-3" *ngIf="loading">
                      Chargement...</p>
                    <p class="text-center font-weight-bold mt-3" *ngIf="reservations.length == 0 && !loading">
                      Aucun élément trouvé</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="currentUser.switch_account == 'artist'">
    <div class="col">
      <div class="card border shadow p-4">
        <div class="align-items-center">
          <div class="d-flex justify-content-between pb-3">
            <div class="div">
              <h2>Content de te revoir, {{(currentUser.profile.full_name != "") ? currentUser.profile.full_name :
                '---'}}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container d-flex justify-content-center align-items-center mt-7" *ngIf="is_connected == false">
  <div class="text-center">
    <div class="mb-4">
      <!-- Icon (you can replace with any appropriate icon) -->
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor"
        class="bi bi-exclamation-circle" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
        <path
          d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm.93-7.481a.58.58 0 0 1 1.138 0l-.272 5.455a.75.75 0 0 1-1.496 0l-.27-5.455z" />
      </svg>
    </div>
    <h2 class="mb-4">Vous n'êtes pas connecté !!</h2>
    <p class="mb-4">Veuillez vous connecter ou vous inscrire pour accéder à votre tableau de bord</p>
    <div>
      <!-- Login Button -->
      <a href="javascript:void(0)" (click)="navigateTo('login')" class="btn btn-studiomap me-2"><i
          class="ni ni-key-25 mr-2"></i>Se connecter</a>
      <!-- Register Button -->
      <a href="javascript:void(0)" (click)="navigateTo('register')" class="btn btn-outline-studiomap"><i
          class="ni ni-ruler-pencil mr-2"></i>S'inscrire</a>
    </div>
  </div>
</div>